import '../_bootstrap'

window.axios = window.Axios.create({
  baseURL: '/trip-dashboard/' // @todo move this into Stores
})
